import { gql } from '@apollo/client';

export const REQUEST_MAGIC_LINK_MUTATION = gql`
  mutation attemptMagicLinkRequest($input: MagicLinkRequestInput!) {
    requestMagicLink(input: $input) {
      success
    }
  }
`;
